export type RouteConfig = Omit<ConfigureRouteOptions, 'path'> & {
	path: string; // although we allow string[] in configureRoute, our route generator emits only string
};

type ConfigureRouteOptions = {
	component?: React.ComponentType<any>;
	path?: string | string[];
	disableSPA?: boolean; // if true, disables SPA routing for this route
	backgroundStyle?: 'default' | 'grey';
	ddRum?: {
		// sets a custom DD RUM view name using useSetRumViewName in the layout component
		rumViewName?: string;
		// setting this to true requires calling useSetRumViewName in a child component
		rumViewNameSetByChild?: boolean;
	};
	layout?: 'simple' | 'minimized';
	requiresAccount?: boolean;
	requiresAuthentication?: boolean;
	requiresEmployeeAuthentication?: boolean;
};
/**
 * A HOC that configures the react router with route configuration. This must be used with the typescript configure-route-transformer
 * which will rip the HOC out and only use it for configuration.
 *
 * @param config Route configuration data.
 * @param component The component being wrapped.
 */
export function configureRoute<P extends object>(config: ConfigureRouteOptions, Component: React.ComponentType<P>): React.ComponentType<P> {
	return Component;
}
